import "moment/locale/ru";
import "./styles/index.scss";
import {AppProviders} from "./providers";
import {AppRouting} from "./routing";

export const App = () => {
  return (
    <AppProviders>
      <AppRouting/>
    </AppProviders>
  );
};